import { UserData } from '@combinativ/user-data';

export function loadUserData(): UserData {
    const tag = document.querySelector('script[type="user-data"]');
    if (!tag || !tag.textContent) {
        throw new Error('User data could not be found on the page');
    }
    return JSON.parse(tag.textContent);
}
